interface CancellationError {
  ERROR_TYPE: 'W'
  ERROR_NUMBER: '5001' | '3002' | '3003' | '3004'
  ERROR_TEXT: string
}

const errorsMap: Record<string, CancellationError> = {
  USER_CANCELLATION: {
    ERROR_TYPE: 'W',
    ERROR_NUMBER: '3002',
    ERROR_TEXT: 'The FlightVoucher payment process has been cancelled manually.',
  },
  SESSION_TIMEOUT: {
    ERROR_TYPE: 'W',
    ERROR_NUMBER: '3003',
    ERROR_TEXT: 'For security reasons the session timed out.',
  },
  CARD_PAYMENT: {
    ERROR_TYPE: 'W',
    ERROR_NUMBER: '5001',
    ERROR_TEXT: 'The additional payment by credit card has ultimately failed. The FlightVoucher payment process has been cancelled.',
  },
  TOO_MANY_RETRIES: {
    ERROR_TYPE: 'W',
    ERROR_NUMBER: '3004',
    ERROR_TEXT: 'The voucher code or name was entered incorrectly too many times. The FlightVoucher payment process has been cancelled.',
  },
}

export default function cancellationUrlWithError(url: string | undefined, kind: string): string {
  if (!url) {
    return ''
  }

  const error = errorsMap[kind]
  if (!error) {
    return url
  }

  const query = Object.entries(error).map(([key, value]) => (
    `${key}=${encodeURIComponent(value)}`
  )).join('&')

  const joinSymbol = url.includes('?') ? '&' : '?'
  return [url, query].join(joinSymbol)
}
